<button
  type="button"
  mat-icon-button
  class="language-trigger-btn"
  [class.language-trigger-btn--open]="languageMenuOpened"
  [matMenuTriggerFor]="languages"
  [matMenuTriggerRestoreFocus]="false"
  (menuOpened)="languageMenuOpened = true"
  (menuClosed)="languageMenuOpened = false"
  (mousedown)="$event.preventDefault()"
>
  <ng-container
    *ngTemplateOutlet="flagImage; context: { $implicit: activeLang }"
  ></ng-container>
</button>

<!-- Language menu -->
<mat-menu
  #languages="matMenu"
  xPosition="before"
  yPosition="below"
  [overlapTrigger]="false"
  class="language-menu-panel-layout"
>
  <div class="language-menu-card">
    @for (lang of availableLangs; track trackByFn($index, lang)) {
      <button
        type="button"
        class="language-menu-row"
        [class.language-menu-row--active]="(lang.id ?? lang) === activeLang"
        (click)="setActiveLang(lang.id ?? lang)"
      >
        <div class="language-menu-text-wrap">
          <div class="language-menu-title">
            {{ lang.label ?? lang }}
          </div>
        </div>
      </button>

      @if (!$last) {
        <div class="language-menu-divider"></div>
      }
    }
  </div>
</mat-menu>

<ng-template let-lang #flagImage>
  <span class="relative w-6 overflow-hidden">
    <img
      class="w-full"
      [src]="'assets/images/flags/tabler-icon-world.svg'"
      [alt]="'Flag image for ' + lang"
    />
  </span>
</ng-template>
